import { useTranslation } from 'react-i18next';
import { accountingSyncToolbarButtons } from '../../config/accountingSyncToolbarConfig';

export interface AccountingSyncStatusToolbarProps {
  onStatusChange?: (status?: string) => void;
  active: string;
  setActive: (key: string) => void;
}

export const AccountingSyncStatusToolbar = ({
  onStatusChange,
  active,
  setActive,
}: AccountingSyncStatusToolbarProps) => {
  const { t } = useTranslation('accountingSyncModule');

  return (
    <div
      className="flex bg-card-bg rounded-lg text-sm p-1 mb-4 overflow-x-auto scrollbar-hide light:border-card-border light:border"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {accountingSyncToolbarButtons.map((btn) => (
        <a
          key={btn.key}
          href={btn.link}
          onClick={(e) => {
            e.preventDefault();
            setActive(btn.key);
            onStatusChange?.(btn.status);
          }}
          className={`px-3 py-1 rounded hover:bg-hover-press whitespace-nowrap ${
            active === btn.key ? 'bg-hover-press' : ''
          }`}
        >
          {t(`toolbar.${btn.key}`)}
        </a>
      ))}
    </div>
  );
};
